//#region Imports
import React from "react";

// Components
import DesktopHeader from "./Desktop Header";
import MobileHeader from "./Mobile Header";
//#endregion

/**
 * Creates an adaptive header for mobile and desktop devices
 * @param {Object} props Props of the component
 * @param {Boolean} props.isDesktop Boolean value to determine whenether it desktop or mobile render needed
 * @param {Number} props.xPaddings Paddings on the X axis
 * @returns {JSX.Element}
 */
const Header = ({ isDesktop, xPaddings }) => {
  return (
    <>
      {isDesktop ? (
        <DesktopHeader xPaddings={xPaddings} />
      ) : (
        <MobileHeader xPaddings={xPaddings} />
      )}
    </>
  );
};

export default Header;
